import React from 'react';

export default function Footer() {
  return (
    <footer className="footer">
      &copy; {new Date().getFullYear()} NodexaRPC. Multi-chain RPC infrastructure.
    </footer>
  );
}
